import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import Container from '../../UI/landingPage/Container'
import gallery from '../../assets/images/lp-gallery.png'

const Gallery = () => {

  useEffect(() => {
    AOS.init({ duration: 2000, once: true, })
  }, [])

  return (
    <div className='bg-[#0C1717] py-20 pt-56 -mt-40 lp-md:pt-48 lp-md:pb-10 lp-sm:pt-48 lp-sm:pb-10'>
      <Container>
        <div className='w-[85%] lp-md:w-full lp-sm:w-full mx-auto' data-aos='fade-up'>
          <img src={gallery} alt="gallery" />
        </div>
      </Container>
    </div>
  )
}

export default Gallery